import {
  CLASS_ANSWER_INDICATOR,
  CLASS_ANSWER_STATEMENT,
  CLASS_SINGLE_ANSWER_HOVER,
  CLASS_ANSWER_STATEMENT_SELECTED,
} from './enquiryCommons';

/**
 * @name showResult
 * @description Zobrazí animovaný výsledek odpovědi dané ankety.
 * Pokud se odpověď shoduje s vybranou, zvýrazní ji.
 *
 * @param {HTMLElement} answer Jednotlivá odpověď ankety.
 * @param {String} percent Procento odpovědí z celkového součtu, ve tvaru např. 5%.
 * @param {String} [selectedAnswer=''] Identifikátor vybrané odpovědi. Pokud není uveden, nezvýrazní se žádná odpověď.
 */
const showResult = (answer, percent, selectedAnswer) => {
  answer.classList.remove(`${CLASS_SINGLE_ANSWER_HOVER}`);
  answer.querySelector(`.${CLASS_ANSWER_INDICATOR}`).style.width = percent;
  const answerStatement = answer.querySelector(`.${CLASS_ANSWER_STATEMENT}`);
  answerStatement.insertAdjacentHTML('beforeend', `<span class="percentage">${percent}</span>`);

  if (answer.dataset.answerId === selectedAnswer) {
    answerStatement.classList.add(`${CLASS_ANSWER_STATEMENT_SELECTED}`);
  }
};

export default showResult;
